/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * License plate of a vehicle. Separated into three parts.   (german: Kennzeichen)   (bipro-fahrzeug::AmtlichesKennzeichen)
 */
export interface LicensePlate {
  /**
   * The first part which identifies the city/location (up to 3 characters).   (german: Ortskennzeichen)
   */
  prefix?: string;
  /**
   * Second part of license plate (up to 2 characters).
   */
  suffix1?: string;
  /**
   * Third part of license plate (up to 4 digits).
   */
  suffix2?: string;
}
